import { render, staticRenderFns } from "./ListItemPiutangByAging.vue?vue&type=template&id=23f2c6c6&scoped=true"
import script from "./ListItemPiutangByAging.vue?vue&type=script&lang=js"
export * from "./ListItemPiutangByAging.vue?vue&type=script&lang=js"
import style0 from "./ListItemPiutangByAging.vue?vue&type=style&index=0&id=23f2c6c6&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "23f2c6c6",
  null
  
)

export default component.exports